import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100 py-12 md:py-16" aria-label="常见问题">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="读者常见疑问"
          desc="关于更新、追更与阅读的常见问题，这里都有答案。"
          align="center"
          action={
            <Link
              to="/faq"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              查看全部问答 <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <div className="space-y-3">
          {preview.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line" />
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}